import _ from 'lodash';
import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import { browserHistory } from 'react-router';
import { readComponentInstanceResourceList } from '../../lib/frankly';
import { buildNotFoundPageURL } from 'utils/UrlUtils';
import ComponentLoader from '../../../shared/utils/ComponentLoader';
import {withResources} from 'lib/redux';
import sysConfig from '../../../server/config';
import { APOLOGIES_URL } from 'constants/URL';

const COMPONENT_MAX_TIME_TO_LOAD = 2000;

class ComponentContainer extends Component {
  static propTypes = {
    resources: PropTypes.object,
    params: PropTypes.object,
    componentDefinition: PropTypes.object.isRequired,
    componentInstanceId: PropTypes.string.isRequired,
    onComponentRender: PropTypes.func,
    spans: PropTypes.object
  }

  static contextTypes = {
    flux: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired
  }

  state = {
    ComponentClass: null,
    componentClassImportError: null,
    rawResponses: null,
    requestError: null,
    stickyState: '',
    initialOffset: 0,
    initialWidth: 0,
    topOffset: 0,
    domId: _.uniqueId('ComponentContainer_')
  }

  componentWillMount() {
    const {
      componentDefinition: {
        id,
        resourceEndpoints: cdre,
        FRN_resourceEndpoints
      } = {}
    } = this.props;

    const resourceEndpoints = FRN_resourceEndpoints || cdre || [];

    let {ComponentClass, rawResponses} = this.state;

    if (typeof window === 'undefined' && sysConfig.ssr.settings.SSR_ON) { // run on server-side only
      ComponentClass = ComponentClass ? ComponentClass : this.getComponentClass();
      rawResponses = rawResponses ? rawResponses : this.getRawResponses();
    }

    if (typeof window !== 'undefined') {
      if (!ComponentClass) {
        ComponentLoader.importReactComponent(id).then(CompClass =>
          this.setState({ ComponentClass: CompClass })
        ).catch(error => {
          console.error('Error loading component: ', id, error);
          this.setState({ componentClassImportError: error })
        });
      }

      if (this.props.resources
        && this.props.componentDefinition.id !== 'components/weather/CurrentConditionsAtAGlance'
        && this.props.componentDefinition.id !== 'components/weather/MeteorologistForecast'
        && this.props.componentDefinition.id !== 'components/weather/DailySummaryWithVideo'
      ) {
        rawResponses = resourceEndpoints
          .map(r => this.props.resources[r.url.replace(/\$\{id\}/, this.props.params.id)])
          .filter(i => i && !i.error);
      }

      if (Array.isArray(rawResponses) && rawResponses.length) {
        this.setState({rawResponses});
      } else {
        if (_.size(resourceEndpoints) > 0) {
          readComponentInstanceResourceList(this).then(resps => {
            if (_.some(resps, 'error')) {
              this.setState({ requestError: resps });
            } else {
              this.setState({ rawResponses: resps });
            }
          }).catch(error =>
            this.setState({ requestError: error })
          );
        }
      }
    } // <-- closing braket for check on (typeof window !== 'undefined')
  }

  componentDidMount() {
    const {
      onComponentRender: notifyParentOfRender
    } = this.props;

    if (notifyParentOfRender) {
      if (this.shouldComponentRender()) {
        this.notifyRenderCompletion();
      } else {
        this.parentNotificationTimeout = setTimeout(() => this.notifyRenderCompletion(), COMPONENT_MAX_TIME_TO_LOAD);
      }
    }
  }

  componentDidUpdate() {
    const {
      flux
    } = this.context;
    const {
      rawResponses,
      requestError
    } = this.state;
    const {
      componentDefinition: {
        props: {
          title = ''
        } = {}
      } = {}
    } = this.props;

    if (this.isComponentPrimaryContentSource()) {
      if (window && (requestError instanceof Error || !_.isEmpty(requestError))) {
        const redirectUrl = buildNotFoundPageURL(window.location.href, APOLOGIES_URL);

        browserHistory.push(redirectUrl);
      }

      if (rawResponses) {
        const [{
          data: {
            headline = '',
            contentClassification = '',
            seo: {
              browsertitle = ''
            } = {},
            type = '',
            widgets = [] // data node from widget API
          } = {}
        }] = rawResponses;

        // Custom set title take precedence over headlines set from the feed
        const pageTitle = title || browsertitle || headline;
        let finalContentClassification = contentClassification;

        // Set content classification (widget API/story-category API)
        if (widgets.length > 0) {
          const imagesGallery = widgets[0].json.find(item => item.Type === 'ImageGallery');
          finalContentClassification = imagesGallery.adTag || '';
        }

        this.setContentClassification(flux, finalContentClassification);
        this.setTitle(flux, pageTitle);
        this.setPageType(flux, type.substring(0, 1).toUpperCase());
      }
    }

    //Check if we are waiting to tell the parent we have rendered, and we have fulfilled the requirements needed to render
    if (this.parentNotificationTimeout && this.shouldComponentRender()) {
      //The component no longer needs to wait for the delayed callback to notify the parent that it has rendered
      clearTimeout(this.parentNotificationTimeout);
      this.parentNotificationTimeout = null;

      this.notifyRenderCompletion();
    }
  }

  componentWillUnmount() {
    const {
      flux
    } = this.context;

    if (this.isComponentPrimaryContentSource()) {
      this.setContentClassification(flux, '');
      this.setTitle(flux, '');
      this.setPageType(flux, '');
    }

    if (window) {
      window.removeEventListener('scroll', this.onScrollListener);
    }
  }

  onNonSupportedStickyScroll(stickyElement) {
    const $ = window['$'];
    const { stickyState, initialOffset } = this.state;
    const currentStickyState = stickyState;

    const currentWindowOffset = $(window).scrollTop();
    const stickyElementOffsetToTop = $(stickyElement).offset().top;
    const stickyElementHeight = stickyElement.offsetHeight;

    const topOffsetWhenSticky = this.calculateTopOffsetWhenSticky();

    const parent = stickyElement.parentElement;
    const parentOffsetTop = $(parent).offset().top;
    const parentHeight = parent.offsetHeight;

    const stuckPosition = parentHeight + parentOffsetTop;
    const stickPosition = currentWindowOffset + topOffsetWhenSticky;
    const stickyElementBottomPosition = stickPosition + stickyElementHeight;

    switch (currentStickyState) {
      case 'sticky':
        if (stuckPosition <= stickyElementBottomPosition) {
          this.setState({
            stickyState: 'stuck'
          });
        } else if ((initialOffset || parentOffsetTop) > stickPosition) {
          this.setState({
            stickyState: 'default'
          });
        }
        break;
      case 'stuck':
        if (stuckPosition > stickyElementBottomPosition) {
          this.setState({
            stickyState: 'sticky'
          });
        }
        break;
      default:
        if (stickyElementOffsetToTop <= stickPosition) {
          this.setState({
            stickyState: 'sticky',
            initialOffset: stickyElementOffsetToTop,
            initialWidth: stickyElement.offsetWidth
          });
        }
        break;
    }
  }

  getComponentClass = () => {
    const {
      componentDefinition: {
        id,
      } = {}
    } = this.props;

    if (typeof window === 'undefined'
        && (!sysConfig.ssr.components[id] || !sysConfig.ssr.components[id].ssr)) {
      return () => null;
    }

    return ComponentLoader._modules[id] ? ComponentLoader._modules[id] : () => null;
  }

  getRawResponses = () => {
    const {
      componentDefinition: {
        resourceEndpoints: cdre,
        FRN_resourceEndpoints
      } = {}
    } = this.props;

    let rawResponses = [];
    const resourceEndpoints = FRN_resourceEndpoints || cdre || [];

    if (_.size(resourceEndpoints) > 0) {
      rawResponses = resourceEndpoints
          .map(resource => {
            let pat = new RegExp("\/[\u0024][\u007B]id[\u007D]\/", "i");

            if (pat.test(resource.url)) {
                //console.log('>>> GET RAW RESPONSES', resource.url, resource.url.replace('${id}', this.props.params.id));
                const url = resource.url.replace('${id}', this.props.params.id);
                return this.props.resources && this.props.resources[url] ? this.props.resources[url] : null;
            }
            return this.props.resources && this.props.resources[resource.url] ? this.props.resources[resource.url] : null;
          })
          .filter(resource => resource !== null);
    }

    return rawResponses;
  }


  setTitle(flux, headline) {
    flux.getActions('Helmet').updatePrimaryContentSourceTitle(headline);
  }

  setContentClassification(flux, contentClassification) {
    flux.getActions('ContentClassification').updatePrimaryContentSourceContentClassification(contentClassification);
  }

  setPageType(flux, pageType) {
    flux.getActions('Advertisement').updatePrimaryContentSourceTargetingKeyValue('wnpt', pageType);
  }

  isComponentPrimaryContentSource() {
    const {
      componentDefinition: {
        FRN_primaryContentSource
      } = {}
    } = this.props;

    return FRN_primaryContentSource;
  }

  //A component should only render if their ComponentClass has been imported into the platform and it has received
  // any data that it is waiting/an error that the data fetching failed
  shouldComponentRender() {
    const {
      componentDefinition: {
        resourceEndpoints: cdre,
        FRN_resourceEndpoints
      }
    } = this.props;
    const {
      ComponentClass,
      rawResponses,
      requestError
    } = this.state;

    const resourceEndpoints = FRN_resourceEndpoints || cdre || [];

    if (!ComponentClass) {
      // TODO: handle component import error state
      return false;
    } else if (_.size(resourceEndpoints) > 0 && !rawResponses && !requestError) {
      return false;
    }

    return true;
  }

  notifyRenderCompletion() {
    const {
      componentInstanceId,
      onComponentRender: notifyParentOfRender,
      componentDefinition: {
        FRN_moduleSticky
      }
    } = this.props;

    const { domId } = this.state;

    notifyParentOfRender(componentInstanceId);

    if (window) {
      const stickyElement = document.getElementById(domId);

      if (FRN_moduleSticky && stickyElement && !this.onScrollListener) {
        /** Check if position sticky is supported */
        if (!stickyElement.style.position) {
          this.onScrollListener = () => this.onNonSupportedStickyScroll(stickyElement);
        } else {
          this.onScrollListener = () => {
            const { topOffset = 0 } = this.state;
            const calculatedTopOffset = this.calculateTopOffsetWhenSticky();

            if (topOffset !== calculatedTopOffset) {
              this.setState({
                topOffset: calculatedTopOffset
              });
            }
          };
        }

        window.addEventListener('scroll', this.onScrollListener);
      }
    }
  }

  calculateTopOffsetWhenSticky() {
    const $ = window['$'];

    /** Select all element with sticky behavior */
    const listStickyElement = $('[class*="--sticky"]');

    const indexOfComponentInList = $(listStickyElement).index(document.getElementById(this.state.domId));

    if (indexOfComponentInList) {
      let stickyElementBefore = null;

      /** Loop through all sticky elements before in tree node */
      for (let i = 0; i < indexOfComponentInList; i++) {
        const currentCheckingComp = listStickyElement[i];

        const position = window.getComputedStyle(currentCheckingComp).position;
        const offsetToTopViewport = $(currentCheckingComp).offset().top - $(window).scrollTop();

        /** Find the one with position fixed or sticky and is currently sticked to the screen */
        if (/.*sticky|fixed/.test(position) && offsetToTopViewport >= 0) {
          stickyElementBefore = currentCheckingComp;
        }
      }

      /** If there is already an element that is currently sticked to the screen */
      if (stickyElementBefore) {
        /** return its offset to the top of viewport, and plus its current height */
        return $(stickyElementBefore).offset().top - $(window).scrollTop() + stickyElementBefore.offsetHeight;
      }

      return 0;
    } else {
      return 0;
    }
  }

  render() {
    const {
        page: {
            uri
        },
        flux
    } = this.context;

    const {
      componentDefinition: {
        props: baseProps,
        FRN_style,
        FRN_className,
        FRN_moduleSticky,
        FRN_resourceEndpoints
      },
      componentInstanceId,
      spans
    } = this.props;

    let {
        ComponentClass,
        rawResponses,
        requestError,
        domId,
        stickyState,
        topOffset,
        initialWidth
    } = this.state;

    if (typeof window !== 'undefined' && !this.shouldComponentRender()) { // client-side
      return null;
    }

    if (sysConfig.ssr.settings.SSR_ON) { // server-side
      ComponentClass = ComponentClass ? ComponentClass : this.getComponentClass();
      rawResponses = rawResponses ? rawResponses : this.getRawResponses();
    }

    let childProps = Object.assign({}, baseProps, {
        FRN_page: {
            uri: typeof location !== 'undefined' ? location.href : uri
        },
        FRN_componentInstanceId: componentInstanceId,
        FRN_flux: flux,
        FRN_resourceEndpoints
    });

    if (requestError) {
        childProps = Object.assign({}, childProps, { FRN_requestError: requestError });
    } else if (rawResponses) {
        childProps = Object.assign({}, childProps, { FRN_rawResponses: rawResponses });
    }

    const containerClassName = classNames(
      'frankly-core-ComponentContainer',
      FRN_className
    );

    const componentContainerContent = (
      <div className={containerClassName} style={FRN_style}>
        <ComponentClass key={componentInstanceId} {...childProps} spans={spans} resources={this.props.resources} params={this.props.params}/>
      </div>
    );

    if (FRN_moduleSticky) {
      let stickyStyle = {
        top: topOffset || 0,
        position: 'sticky'
      };

      if (stickyState) {
        switch (stickyState) {
          case 'sticky':
            stickyStyle = {
              position: 'fixed',
              top: this.calculateTopOffsetWhenSticky(),
              width: initialWidth ? initialWidth : null
            };
            break;
          case 'stuck':
            stickyStyle = {
              position: 'absolute',
              top: '',
              bottom: 0,
              width: initialWidth ? initialWidth : null
            };
            break;
          default:
            stickyStyle = {
              position: ''
            };
            break;
        }
      }

      return (
        <div id={domId} style={stickyStyle} className="frankly-core-ComponentContainer-Wrapper frankly-core-ComponentContainer-Wrapper--sticky">
            {componentContainerContent}
        </div>
      );
    } else {
        return componentContainerContent;
    }
  }
}

export default withResources(ComponentContainer);



// WEBPACK FOOTER //
// ./app/components/core/ComponentContainer.js